/** Daily reports are calendar dates; keep their date stable across browser time zones. */
export const chartDateKey = (value: string): string => {
  const key = String(value || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(key)) return '';
  const date = new Date(`${key}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === key ? key : '';
};
export const formatChartDate = (value: string, full = false): string => {
  const key = chartDateKey(value);
  if (!key) return 'Unknown date';
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric', month: full ? 'long' : 'short',
    ...(full ? { weekday: 'short' as const, year: 'numeric' as const } : {}),
    timeZone: 'UTC',
  }).format(new Date(`${key}T00:00:00Z`));
};
export const sortDailyReports = <T extends { date: string }>(rows: T[]): T[] =>
  rows.filter(row => chartDateKey(row.date)).slice().sort((a, b) => chartDateKey(a.date).localeCompare(chartDateKey(b.date)));
